import type { ReactElement } from 'react'
import React from 'react'

import { SPACE } from '@ui-kit/constants'

import type { Props } from './types'

const Spacer = (props: Props): ReactElement => (
  <div style={props.horizontal ? { width: SPACE[props.size] } : { height: SPACE[props.size] }} />
)

export default Spacer
